<script>
  export default {
    functional: true,
    props: {
      nodes:{
        type: Object,
        required: true
      }
    },
    render(_, { props }) {
      return props.nodes
    }
  }
</script>